import styled from "@emotion/styled";
import { Box, BoxProps, IconButton, ImageList } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
	width: "500px",
	[theme.breakpoints.down("sm")]: {
		width: "100%"
	}
}));

export const ActiveImage = styled(Box)({
	position: "relative",
	display: "flex",
	alignItems: "center",
	justifyContent: "center"
});

export const ItemImage = styled.img(({ theme }) => ({
	height: "432px",
	width: "500px",
	objectFit: "contain",
	[theme.breakpoints.down("sm")]: {
		width: "100%",
		height: "auto"
	}
}));

interface ThumbnailsProps extends BoxProps {
	index: number;
	activeIndex: number;
	component: any;
	type: any;
}

export const ThumbnailsContainer = styled(ImageList)({
	marginTop: "4px",
	width: "fit-content",
	marginLeft: "auto",
	marginRight: "auto"
});

export const Thumbnails = styled(Box)<ThumbnailsProps>(({ index, activeIndex, theme }) => ({
	border: index === activeIndex ? "2px solid" : "1px solid",
	borderColor:
		index === activeIndex
			? theme.project.colors.primaryColors.main
			: theme.project.colors.allColors.hex.grayscale.gray300,
	padding: 0,
	borderRadius: "4px",
	overflow: "hidden",
	cursor: "pointer",
	background: "transparent",
	display: "block",
	width: "50px"
}));

export const Thumbnail = styled(Box)<any>({
	display: "block",
	width: "50px",
	height: "40px",
	objectFit: "contain"
});

export const NextIconButton = styled(IconButton)({
	position: "absolute",
	right: 8,
	zIndex: 1,
	backgroundColor: "rgba(255, 255, 255, 0.8)"
});

export const PreviousIconButton = styled(IconButton)({
	position: "absolute",
	left: 8,
	zIndex: 1,
	backgroundColor: "rgba(255, 255, 255, 0.8)"
});
